import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import Avatar, {
	AvatarProps,
} from '../../../../../../ReactSharedScripts/components/Avatar';
import stringUtils from '../../../../../../ReactSharedScripts/utils/string';
import { RouteLink } from '../../../../../../ReactSharedScripts/components/RouteLink';

type SpreadsheetAvatarProps = AvatarProps & {
	className?: string;
	title: string | JSX.Element | null;
	titleUrl?: string | null;
} & Pick<AvatarProps, 'size'>;

export const SpreadsheetAvatar: FC<SpreadsheetAvatarProps> = ({
	className,
	photoUrl,
	initials,
	size,
	title,
	titleUrl,
}) => {
	const componentClasses = classNames(classes.spreadsheetAvatar, className);
	const hasLink = !stringUtils.isNullOrEmpty(titleUrl);

	return (
		<div className={componentClasses}>
			<Avatar
				photoUrl={photoUrl}
				initials={initials}
				size={size}
			/>
			<span className={classes.avatarTitle}>
				{hasLink && title && (
					<RouteLink
						href={titleUrl ? titleUrl : ''}
						hasColor={false}
					>
						{title}
					</RouteLink>
				)}
				{!hasLink && title}
			</span>
		</div>
	);
};
